<template>
  <div class="form-group">
    <label :for="exampleFormControlTextarea1">
      <slot />
    </label>
    <textarea
      class="form-control"
      rows="5"
      :id="exampleFormControlTextarea1"
      :value="modelValue"
      :placeholder="placeholder"
      @input="onInput"
      :disabled="read"
    ></textarea>
  </div>
</template>

<script>
export default {
  name: "argon-textarea",
  props: {
    id: String,
    placeholder: String,
    modelValue: {
      type: String,
      default: "",
    },
    read:{
      type:Boolean,
      default:false
    }
  },
  emits:["update:modelValue"],
  methods: {
    onInput(e){
      this.$emit("update:modelValue",e.target.value)
    },
  }
};
</script>